/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { Injectable } from '@angular/core';
import { RolePermissionDetailsModel } from '@app/models/role-permission-details.model';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { GET_ROLE_PERMISSIONS_BY_ROLEID, GET_ROLE_PERMISSIONS_BY_ROLEID_AND_PERMISSIONID } from './role-permission-details-queries';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionDetailsService {
  private _rolePermissionDetail: RolePermissionDetailsModel;
  public rolePermissionDetailList: RolePermissionDetailsModel[];
  protected _endpoint = 'role_permissions_details';

  constructor(
    http: HttpClient,
    authUserService: AuthUserService,
    private apollo: Apollo
  ) {}

  get rolePermissionDetail(): RolePermissionDetailsModel {
    return this._rolePermissionDetail;
  }

  set rolePermissionDetail(value: RolePermissionDetailsModel) {
    this._rolePermissionDetail = value;
  }

  public getRolePermissionDetailsByIdAndPermissionId(roleId: string, permissionId: string): Observable<RolePermissionDetailsModel> {
    return new Observable(subscriber => {
      this.apollo.query({
        query: GET_ROLE_PERMISSIONS_BY_ROLEID_AND_PERMISSIONID,
        variables: {
          condition: {
            roleId: roleId,
            permissionId: permissionId
          }
        }
      }).subscribe((result: any) => {
        this.rolePermissionDetailList = result.data.rolePermissionsDetails.map(
          roleDetails => { return Object.assign(new RolePermissionDetailsModel(), roleDetails) });
        subscriber.next(this.rolePermissionDetail);
        subscriber.complete();
      });
    });
  }


  /**
   *  Cormac
   *
   *  getRolePermissionDetailsByRoleId
   *
   * : Get an RolePermissionDetails based on their ids by filtering the API query
   *
   * @param roleId of type string
   * @param permissionId of type string
   *
   * @returns Void: gets the RolePermissionDetails with the id that meets the query
   */

  getRolePermissionDetailsByRoleId(roleId: string): Observable<RolePermissionDetailsModel[]> {
    return new Observable(subscriber => {
      this.apollo.query({
        query: GET_ROLE_PERMISSIONS_BY_ROLEID,
        variables: {
          condition: {
            roleId: roleId
          }
        }
      }).subscribe((result: any) => {
        this.rolePermissionDetailList = result.data.rolePermissionsDetails.map(roleDetails => {
          return Object.assign(new RolePermissionDetailsModel(), roleDetails)
        });
        subscriber.next(this.rolePermissionDetailList);
        subscriber.complete();
      });
    });
  }
}
